import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import { useRequestIds } from '~/contexts/InventoryContext';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';

function useTrackMegaSuggestions() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { keywordSuggestion, setKeywordSuggestion } = useContext(
    SearchEventsDataContext
  );
  const requestIds = useRequestIds();

  const data = {
    ...requestIds,
    buildKey: keywordSuggestion?.buildKey || null,
    isStickySearchbar: keywordSuggestion?.isStickySearchbar || null,
    suggestionIndex: keywordSuggestion?.suggestionIndex || null,
    suggestionsLength: keywordSuggestion?.suggestionsLength || null,
    suggestionText: keywordSuggestion?.suggestionText || null,
    textEntered: keywordSuggestion?.textEntered || null,
    textSource: keywordSuggestion?.textSource || null
  };

  const fireEvent = () => {
    trackEvent('mega-srp-keyword-suggestion', data, undefined, {
      useFetch: true,
      fetchOption: { keepalive: false }
    });
    setKeywordSuggestion({});
  };

  return {
    data,
    fireEvent
  };
}

export default useTrackMegaSuggestions;
